import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getKindProducts = () =>
  fetch(
    `${API_BASE_URL}/kind-products`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  .then(res => res.json())


export const saveKindProduct = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/kind-products`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editKindProduct = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/kind-products/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deleteKindProduct = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/kind-products/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  return await res.json()
}